import React from 'react'

import { Button, CubeOutline, ThreeDPrintOnly } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf,
  bool,
  shape,
  string,
} from 'prop-types'

import { buildLocalizedPath } from 'Utils/getLocalizedUrl'

const COLUMN_ICONS = {
  cg: CubeOutline,
  print: ThreeDPrintOnly,
}

// Four placeholder rows roughly fill a result column, so the skeleton reserves the height the
// results will occupy and they swap in without a jump. Static keys - the rows never reorder.
const SKELETON_ROWS = ['a', 'b', 'c', 'd']

function buildSearchHref({ browsePath, printReady, query, searchPath }) {
  const trimmedQuery = query?.trim()

  if (!trimmedQuery) {
    return buildLocalizedPath(`${browsePath}?page=1`)
  }

  const params = new URLSearchParams()
  params.set('keywords', trimmedQuery)
  if (printReady) params.set('print_ready', '1')

  return buildLocalizedPath(`${searchPath}?${params.toString()}`)
}

function CategoryColumn({
  columnKey,
  title,
  searchLabel,
  searchPath,
  browsePath,
  printReady = false,
  items,
  isLoading = false,
  query = '',
}) {
  const HeaderIcon = COLUMN_ICONS[columnKey]

  const handleSearch = () => {
    window.location.href = buildSearchHref({ browsePath, printReady, query, searchPath })
  }

  return (
    <div className="home-search-dropdown__column">
      <div className="home-search-dropdown__column-header">
        {HeaderIcon && <HeaderIcon className="home-search-dropdown__column-icon" aria-hidden="true" />}
        <span className="home-search-dropdown__column-title cgt-caption-semibold">{title}</span>
      </div>

      <div className="home-search-dropdown__column-body">
        {isLoading ? (
          <ul className="home-search-dropdown__skeleton" aria-hidden="true">
            {SKELETON_ROWS.map((rowKey) => (
              <li key={rowKey} className="home-search-dropdown__skeleton-row" />
            ))}
          </ul>
        ) : (
          <ul className="home-search-dropdown__items">
            {items.map((item) => (
              <li key={item.href}>
                <a
                  className="home-search-dropdown__item"
                  href={buildLocalizedPath(item.href)}
                  data-track="home-search-category"
                  data-content-type={columnKey}
                >
                  <span className="home-search-dropdown__item-label cgt-body-base-semibold">{item.label}</span>
                  <span className="home-search-dropdown__item-count cgt-body-base">{item.count}</span>
                </a>
              </li>
            ))}
          </ul>
        )}

        <Button
          type="secondary"
          size="small"
          expand
          actionType="button"
          customClass="home-search-dropdown__search-btn"
          onClick={handleSearch}
          data-track="home-search-submit"
          data-content-type={columnKey}
        >
          {searchLabel}
        </Button>
      </div>
    </div>
  )
}

CategoryColumn.propTypes = {
  columnKey: string.isRequired,
  title: string.isRequired,
  searchLabel: string.isRequired,
  searchPath: string.isRequired,
  browsePath: string.isRequired,
  printReady: bool,
  items: arrayOf(
    shape({
      label: string.isRequired,
      href: string.isRequired,
      count: string,
    })
  ).isRequired,
  isLoading: bool,
  query: string,
}

export default CategoryColumn
